export default __webpack_public_path__ + "static/media/main1.0c78b707.jpg";